const flattenObject: any = (
  o: { [key: string]: any },
  key = '',
  res: { [key: string]: any } = {}
) => {
  Object.keys(o).forEach((k: string) => {
    const v = o[k];
    typeof v === 'object'
      ? flattenObject(v, key + (isNaN(parseFloat(k)) ? `${k}` : `[${k}].`), res)
      : (res[key + k] = v);
  });
  return res;
};

export default flattenObject;
